var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.changeType === 1
      ? _c("div", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("GlobalSetObj.Selecionadas")) +
              "：" +
              _vm._s(_vm.selectedData.length) +
              " "
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "el-form",
                {
                  ref: "changeSiteForm",
                  attrs: { model: _vm.changeSiteForm, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "selectValue" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "div",
                          { staticClass: "selectLabel" },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "225px" },
                                on: { change: _vm.switchType },
                                model: {
                                  value: _vm.changeSiteForm.operateType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.changeSiteForm,
                                      "operateType",
                                      $$v
                                    )
                                  },
                                  expression: "changeSiteForm.operateType",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "1",
                                  attrs: {
                                    label: _vm.$t(
                                      "tablePrice.modifyResponsibleHub"
                                    ),
                                    value: 1,
                                  },
                                }),
                                _c("el-option", {
                                  key: "2",
                                  attrs: {
                                    label: _vm.$t(
                                      "tablePrice.modifyResponsibleStage"
                                    ),
                                    value: 2,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm.changeSiteForm.operateType === 1
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: this.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.changeSiteForm.selectValue,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.changeSiteForm,
                                    "selectValue",
                                    $$v
                                  )
                                },
                                expression: "changeSiteForm.selectValue",
                              },
                            },
                            _vm._l(_vm.siteIdList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          )
                        : _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.changeResponsibilityStage },
                              model: {
                                value: _vm.changeSiteForm.selectValue,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.changeSiteForm,
                                    "selectValue",
                                    $$v
                                  )
                                },
                                expression: "changeSiteForm.selectValue",
                              },
                            },
                            _vm._l(
                              _vm.responsibilityTypeList.responsibility_stage,
                              function (item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.value, value: item.key },
                                })
                              }
                            ),
                            1
                          ),
                    ],
                    2
                  ),
                  _vm.changeSiteForm.selectValue == 2
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.ResponsibleParty"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("collectionCenter.tudo"),
                                clearable: "",
                              },
                              model: {
                                value: _vm.changeSiteForm.responsibilityParty,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.changeSiteForm,
                                    "responsibilityParty",
                                    $$v
                                  )
                                },
                                expression:
                                  "changeSiteForm.responsibilityParty",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.trunkLine"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("orderCenterCont.region"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _c("div", [
          _c("span", { staticStyle: { "margin-right": "20px" } }, [
            _vm._v(
              _vm._s(_vm.$t("fixDutyFine.TotalModification")) +
                "：" +
                _vm._s(_vm.changeReturnData.totalCount)
            ),
          ]),
          _c("span", { staticStyle: { "margin-right": "20px" } }, [
            _vm._v(
              _vm._s(_vm.$t("GlobalSetObj.ModificationSuccessful")) +
                "：" +
                _vm._s(_vm.changeReturnData.success)
            ),
          ]),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("GlobalSetObj.failTotal")) + "："),
            _c("span", { staticStyle: { color: "#dd4a68" } }, [
              _vm._v(_vm._s(_vm.changeReturnData.fail)),
            ]),
          ]),
          _vm.changeReturnData.fail > 0
            ? _c("div", [
                _c("div", { staticStyle: { margin: "10px 0" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("fixDutyFine.ModificationFailedOrderNumber")
                    ) + "："
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "max-height": "300px",
                      "overflow-y": "auto",
                    },
                  },
                  _vm._l(_vm.changeReturnData.failList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { "margin-bottom": "5px" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(index + 1) +
                            "." +
                            _vm._s(item.waybillNumber) +
                            "，" +
                            _vm._s(item.reason) +
                            " "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }